const endpointName = 'SavedItineraries';
const Endpoints = {
  /**
   * @description getting the itinerary from the saved itinerary
   * @param savedItineraryId {string} = the saved itinerary id
   * @param agencyId {string} = agency id
   * @param agentId {string} = agent id
   * @returns a promise
   */
  getItinerary: function (savedItineraryId, agencyId, agentId) {
    return this.get(`/api/${endpointName}/getItineraryFrom?id=${savedItineraryId}&agencyId=${agencyId}&agentId=${agentId}`);
  },
  /**
   * @description download Itinerary example
   * @param savedItineraryId {string} = the saved itinerary id
   * @param agencyId {string} = agency id
   * @param agentId {string} = agent id
   * @returns a promise
   */
  downloadItineraryExample: function (savedItineraryId, agencyId, agentId) {
    return this.axios({
      method: 'GET',
      url: `/api/${endpointName}/${savedItineraryId}/${agencyId}/${agentId}/download`,
      responseType: 'blob',
    });
  },
  /**
   * @description get a quote for a saved itinerary
   * @param {*} itineraryShell
   * @param {string} agencyId = agency id
   * @param {string} agentId = agent id
   * @param {string} clientId = client id
   * @returns a promise
   */
  getQuote: function (itineraryShell, agencyId, agentId, clientId) {
    return this.post(`/api/${endpointName}/getQuote`, { itineraryShell, agencyId, agentId, clientId });
  },
  /**
   * @description get the camp info for a saved itinerary
   * @param {string} id = saved itinerary id
   * @param {string} locale = locale of the user
   * @returns a promise
   */
  campInfo: function (id, locale) {
    return this.get(`/api/SavedItineraries/${id}/camp-info${locale ? `?locale=${locale}` : ''}`);
  },
  /**
   * @description get the activity info for a saved itinerary
   * @param {string} id = saved itinerary id
   * @param {string} locale = locale of the user
   * @returns a promise
   */
  activityInfo: function (id, locale) {
    return this.get(`/api/SavedItineraries/${id}/activity-info${locale ? `?locale=${locale}` : ''}`);
  },
};

export default Endpoints;
